import { Button } from '@/components/ui/Button';
interface HowToPlayProps {
  onClose: () => void;
  onStartGame: () => void;
}
export function HowToPlay({ onClose, onStartGame }: HowToPlayProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-3xl shadow-[0_20px_60px_-15px_rgba(0,0,0,0.3)] p-6 w-full max-w-[340px]">
        <h2 className="text-2xl font-extrabold text-[#1a1a1a] text-center mb-6">
          How to Play
        </h2>
        <div className="flex flex-col gap-6 mb-8">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-[#FFD93D] rounded-2xl flex items-center justify-center shadow-[3px_3px_0_0_#B8860B] flex-shrink-0">
              <svg
                className="w-6 h-6 text-[#1a1a1a]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div>
              <h3 className="font-bold text-[#1a1a1a] mb-1">Objective</h3>
              <p className="text-sm text-[#6B7280]">
                Dodge the falling red blocks for as long as possible to score
                points!
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-[#3B82F6] rounded-2xl flex items-center justify-center shadow-[3px_3px_0_0_#1D4ED8] flex-shrink-0">
              <svg
                className="w-6 h-6 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                />
              </svg>
            </div>
            <div>
              <h3 className="font-bold text-[#1a1a1a] mb-1">Controls</h3>
              <p className="text-sm text-[#6B7280]">
                <span className="font-medium">Desktop:</span> Arrow keys or A/D
                <br />
                <span className="font-medium">Mobile:</span> Swipe left/right or
                tap sides
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-[#E63946] rounded-2xl flex items-center justify-center shadow-[3px_3px_0_0_#991B1B] flex-shrink-0">
              <svg
                className="w-6 h-6 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
            </div>
            <div>
              <h3 className="font-bold text-[#1a1a1a] mb-1">Difficulty</h3>
              <p className="text-sm text-[#6B7280]">
                Blocks fall faster and spawn more frequently as you survive!
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <Button onClick={onStartGame} variant="primary">
            Start Playing
          </Button>
          <Button onClick={onClose} variant="secondary">
            Back to Menu
          </Button>
        </div>
      </div>
    </div>
  );
}